export const mainGoldFont = {
  dropShadow: true,
  dropShadowAngle: 1.6,
  dropShadowAlpha: 0.5,
  dropShadowDistance: 4,
  dropShadowColor: "#424142",
  fill: [
    "#feff00",
    "#feffe8",
    "#feff00",
    "#ff7800"
  ],
  fillGradientStops: [
    0.2,
    0.5,
    0.7
  ],
  lineJoin: "round",
  miterLimit: 0,
  stroke: "#700000",
  strokeThickness: 5,
  whiteSpace: "normal"
};

export const freespinsPopupsFont = {
  dropShadow: true,
  dropShadowAngle: 1.6,
  dropShadowBlur: 4,

  dropShadowColor: "#e9010a",
  dropShadowDistance: 1,
  fill: [
    "#ff6e02",
    "#ffff00",
    "#f2ff79",
    "#ffff00",
    "#ff6d00"
  ],
  fillGradientStops: [
    0.2,
    0.4,
    0.5,
    0.6,
    0.88
  ],
  leading: 7,
  lineJoin: "round",
  miterLimit: 12,
  padding: 1,
  // stroke: "#850105",
  stroke: "#b20107",
  strokeThickness: 14,
  whiteSpace: "normal"
}

export const jackpotValues = {
  dropShadow: true,
  dropShadowBlur: 2,
  dropShadowAngle: 1.6,
  dropShadowDistance: 4,
  fill: 'white',
  lineJoin: 'round',
  miterLimit: 0,
  strokeThickness: 8,
  whiteSpace: 'normal',
};

export const jackpotStrokes = {
  0: { stroke: '#8f1dab', strokeThickness: 6,  dropShadowColor: "#1d0450", dropShadowAlpha: 1,},
  // 1: { stroke: '#990000', strokeThickness: 6 , dropShadowColor: "#751702"},
  // 1: { stroke: '#135a4c', strokeThickness: 6 , dropShadowColor: "#0a2c23"},
  1: { stroke: '#135a4c', strokeThickness: 6 , dropShadowColor: "#0e3b30"},
  2: { stroke: '#aa2e35', strokeThickness: 6 ,  dropShadowColor: "#5c1a20", dropShadowAlpha: 1,},
};
